import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTranslation } from "react-i18next";
import BookingGetters from "../../store/onlineBooking/getters";
import ShareboxHeader from "./components/ShareboxHeader";
import ShareboxFooter from "./components/ShareboxFooter";

const REDIRECT_DELAY_MS = 2000;

type Props = {
  onBack?: () => void;
  onComplete?: () => void;
};

export default function D11Complete({ onBack, onComplete }: Props) {
  const { t: translate } = useTranslation();
  const appSettings = BookingGetters.getAppSettings();

  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;
  useEffect(() => {
    const timer = setTimeout(
      () => onCompleteRef.current?.(),
      REDIRECT_DELAY_MS
    );
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <ShareboxHeader
        logoUrl={appSettings?.config?.logoUrl}
        rightSlot={translate("Completed")}
        onBack={onBack}
      />

      <Box
        sx={{
          flex: 1,
          maxWidth: 480,
          mx: "auto",
          px: 3,
          py: 6,
          textAlign: "center",
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 72, color: "success.main", mb: 2 }} />
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          {translate("All done!")}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {translate("Your check-in is complete. Enjoy your rental!")}
        </Typography>
      </Box>
      <ShareboxFooter />
    </Box>
  );
}
